import React from "react";
import { User } from "src/entities/User";
import { ProgramContainer } from "src/entities/formTemplateDataType";
import { RuntimeComponent } from "./RuntimeComponent";
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { MsalProvider } from '@azure/msal-react';
// import { msalConfig } from './security/authConfig';
// import { PublicClientApplication } from '@azure/msal-browser';
import { LoginCallback, SecureRoute, Security } from "@okta/okta-react";
import { BrowserRouter as Router, Route, withRouter } from 'react-router-dom';
import msalInstance from "./security/msalInstance";
import * as CircularJSON from 'circular-json';
import { getAppNameFromPath } from "./utilities/URLUtils";
import { getEnvVar } from "./config/RuntimeConfig";



interface Props {

}

interface State {
    programContainer: ProgramContainer
    isEng: boolean
}


export class RuntimeApp extends React.Component<Props, State> {
    user: User;
    // msalInstance = new PublicClientApplication(msalConfig);
    constructor(props) {
        super(props);
        this.state = {
            isEng: true,
            programContainer: null
        }
    }

    async componentDidMount() {
        //coming from env file. 
        //each app has its own docker and env file so LAYOUT_STRING is different
        if (getEnvVar('LAYOUT_STRING')) {
            const programContainer = CircularJSON.parse(getEnvVar('LAYOUT_STRING')) as ProgramContainer;
            this.setState({
                programContainer: programContainer
            });
        }
    }
  
    render() {
        if (!this.state.programContainer)
            return null;

        if (this.state.programContainer.AuthRequired == "ad") {
            return (
                <MsalProvider instance={msalInstance}>
                    <RuntimeComponent programContainer={this.state.programContainer}></RuntimeComponent>
                </MsalProvider>
            )
        } else {
            return <RuntimeComponent programContainer={this.state.programContainer}></RuntimeComponent>
        }
    }
}